const spConfig = {
  env: process.env.REACT_APP_API_URL === "https://api-qa.hepsiglobal.com/api/v1" 
        ? "qa" 
        : process.env.REACT_APP_API_URL === "https://api.hepsiglobal.com/api/v1" 
          ? "prod"
          : 'dev',
  storageURL: process.env.REACT_APP_API_URL === "https://api-qa.hepsiglobal.com/api/v1" 
              ? "https://storage.googleapis.com/global-api-qa" 
              : "https://cdn.hepsiglobal.com",
  acceptedMediaFiles:["jpg", "JPG", "jpeg", "JPEG", "webp", "WEBP", "png", "PNG"],
  acceptedExcelFiles:["xls", "XLS", "xlsx", "XLSX"],
  acceptedLogoExtension:["jpg", "JPG", "jpeg", "JPEG", "png", "PNG"],
  acceptedLogoFileSize:400000, // Bytes
  maxImageFileSize: 9000000, // Bytes,
  uiLanguages: {
    "en" : "English",
    "tr" : "Türkçe"
  },
  v2CompanyIds: {
    dev: [3096],
    qa: [3096,3101,790,3387],
    prod: [6511]
  }
}

export default spConfig